import React                      from 'react';
// import classnames                 from 'classnames';
// import { QUOTED, PRICE_SELECTED } from 'pu-data/QuoteSteps';
import { findSupplier }           from 'pu-data/Utils';
import PriceMatrix                from './PriceMatrix';

const buildMatrices = (props) => {
  const { quote, supplierInfos } = props;
  if (!quote || !quote.line_items) {
    return [];
  }
  return quote.line_items
    .map((li) => (
      <PriceMatrix
        key={li.product_key}
        lineItem={li}
        supplier={findSupplier(supplierInfos, li.product_key)}
        parametersChanged={props.parametersChanged}
        {...props} />
    ));
};

const PriceMatrices = (props) => {
  // const isVisible = [QUOTED, PRICE_SELECTED].indexOf(props.quoteStep) >= 0;
  return (
    // <div className={classnames('pcb-price-section', { hidden: !isVisible })}>
    <div className="">
      <div className="price-matrices">
        <div id="error_price_matrix" />
        {buildMatrices(props)}
      </div>
    </div>
  );
};

export default PriceMatrices;
